const BILL_DETAIL_ITEM_PREFIX = "billdetail";

export const BILL_DETAIL_ITEM_IDS = {
    ITEM_NAME: (key: string) => `${BILL_DETAIL_ITEM_PREFIX}-itemName_${key}`,
};
